// services/apiFormulario.js
import Validaciones from '../components/utils/Validaciones';

const APIFORMULARIOA05INICIALES = 'https://www.ancogenecop.com/APIANCO/controllers/formularioA05Iniciales.php?op=';

export const guardarAnimal = async (product, mdatosConsecutivo = [],toastRef,puntaje) => {
    const esValido = Validaciones.validarCamposRequeridos(product, toastRef, puntaje);
    console.log(product)
    //return;
    if (!esValido) return 0;
    const campos = [
        "TID_PROPIETARIO", "NID_PROPIETARIO", "COMPOSICION", "CONSECUTIVO", "FECHA_SOLICITUD",
        "CRIADERO", "DIRECCION", "DEPARTAMENTO", "MUNICIPIO", "ESPECIE", "RAZA", "SEXO", "NOMBRE",
        "FECHA_NACIMIENTO", "MARCAS_HATO", "RASGOS_PARTICULARES", "COLOR", "CHIP", "PUNTAJE_FUNDADORES",
        "PREFIJO", "CONCEPCION", "LIBRO", "TID_REGISTRADOR", "NID_REGISTRADOR", "TID_REGISTRADOR1",
        "NID_REGISTRADOR1", "TID_REGISTRADOR2", "NID_REGISTRADOR2", "CHIP_PADRE", "CHIP_ABUELO_PATERNO",
        "CHIP_ABUELA_PATERNA", "CHIP_MADRE", "CHIP_ABUELO_MATERNO", "CHIP_ABUELA_MATERNA"
    ];

    const data = new FormData();

    campos.forEach(key => {
        const valor = mdatosConsecutivo[0]?.[key] ?? product[key] ?? '';
        console.log("valor uno "+key+" valor 2 "+valor)
        data.append(key, valor);  
    });

    data.append("CODIGO", 'A05');
    if (product.FOTO instanceof File) {
        console.log("Cargando imagen:", product.FOTO.name, product.FOTO.type);
        data.append('FOTO', product.FOTO);
    } else {
         console.warn("No se cargó una imagen válida");
          data.append('FOTO', product.FOTO);
    }
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'ingresarAnimalInicial', {
            method: 'POST',
            body: data
        });

        if (!response.ok) throw new Error('Error al guardar el animal');
        //console.log("antes de "+response.text())
        //return await response.text();
        return 1
    } catch (error) {
        console.error('Error en guardarAnimal:', error);
        return 0;
    }
};

export const eliminarAnimal = async (consecutivo,chip,nid_propietario,codigo) => {
    const data = new FormData();
    console.log(consecutivo)
    data.append('CONSECUTIVO', consecutivo);
    data.append('CHIP', chip);
    data.append('NID_PROPIETARIO', nid_propietario);
    data.append('CODIGO', codigo);
  try {
    const response = await fetch(APIFORMULARIOA05INICIALES + 'eliminarAnimal', {
      method: 'POST',
     header: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
      body: data // Solo el número como string
    });

     if (!response.ok) throw new Error('Error al eliminar el animal');
    return 1;
  } catch (error) {
    console.error('Error en eliminarAnimal:', error);
    return 0;
  }
};



export const obtenerConsecutivo = async (product,consecutivo) => {
    //console.log("ramiro celis " + product + "consecutivo" + consecutivo)
     const data = new FormData();
    data.append('NID_PROPIETARIO', product);
    data.append('CONSECUTIVO', consecutivo);
    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'datosConsecutivoSGenalogia', {
            method: 'POST',
            body: data
        });
        return await response.json();
    } catch (error) {
        console.error('Error en obtenerConsecutivo:', error);
        return [];
    }
};

export const datosGenerales = async (nidPropietario, muestra, toast) => {
    const data = new FormData();
    data.append('NID_PROPIETARIO', nidPropietario);

    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'datosUsuario', {
            method: 'POST',
            body: data
        });

        if (!response.ok) throw new Error('Error al obtener animales');
        return await response.json();
    } catch (error) {
        console.error('Error en datosUsuario:', error);
        if (toast?.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo cargar la información desde el servidor',
                life: 5000
            });
        }
        return [];
    }
};

export const obtenerAnimales = async (nidPropietario, muestra, toast) => {
    const data = new FormData();
//    console.log("sadasdf sdf sadlkjasdlf sadl "+nidPropietario)
    const administrador = localStorage.getItem('ADMINANCO');
    const nidStorage = localStorage.getItem('nid_propietario');

    const propietario = (administrador === '1')
        ? (nidPropietario === 0 ? 'ADMINANCO' : nidPropietario)
        : nidStorage;

    data.append('NID_PROPIETARIO', propietario);

    try {
        const response = await fetch(APIFORMULARIOA05INICIALES + 'formulariosA05Iniciales', {
            method: 'POST',
            body: data
        });

        if (!response.ok) throw new Error('Error al obtener animales');
        return await response.json();
    } catch (error) {
        console.error('Error en obtenerAnimales:', error);
        if (toast?.current) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo cargar la información desde el servidor',
                life: 5000
            });
        }
        return [];
    }
};
